/**
 * KAN-8：specimen 瓶號白名單 — client 端鏡像常數。
 *
 * ⚠️ 同步點（single source of truth 的前端鏡像）：
 * 這份是 `server/public/tool/specimen-label.js` 的**前端鏡像**——前端跨 build 邊界
 * 無法 require server 端檔案，故必須複製一份給下拉選單用。
 *
 * **改一處要同步改另一處**：未來 KAN-4（Overall/Each，EVAS 2.0）擴充瓶數（如加 E）時，
 * 這份與 `server/public/tool/specimen-label.js` 的 `SPECIMEN_LABEL_ALLOWED` 必須一起改，
 * 否則前端下拉會出現後端不接受的選項（或反之）。
 */

// 允許的瓶號白名單（大寫）。與 server/public/tool/specimen-label.js 保持一致。
export const SPECIMEN_LABEL_ALLOWED = ['A', 'B', 'C', 'D']
